import type { FinalSong } from '../../interfaces/final-song';
import type { SongsNotFound } from '../../interfaces/playlist-return-object';

// Ports of the Angular pipes in src/app/pipes/ — transform logic copied 1:1.

/**
 * Port of src/app/pipes/trim.pipe.ts (`| trim`).
 * Returns the value unchanged when falsy (e.g. null/undefined/''), trimmed otherwise.
 */
export function trim(value: string): string {
  if (!value) return value;
  return value.trim();
}

/**
 * Port of src/app/pipes/total-active-filters.pipe.ts (`| totalActiveFilters`).
 * Adds 1 to the count for the 'Lyrical Theme' filter group when a
 * lyrics-contains search string is active.
 */
export function totalActiveFilters(
  totalActiveFilters: number,
  title: string,
  lyricsContains?: string | null
): number {
  if (title === 'Lyrical Theme' && lyricsContains) {
    return totalActiveFilters + 1;
  }
  return totalActiveFilters;
}

/**
 * Port of src/app/pipes/not-found-on-export.pipe.ts (`| notFoundOnExport`).
 * True when the song's artist appears in the export's songs-not-found list
 * (matches by artist only, exactly like the pipe).
 */
export function notFoundOnExport(song: FinalSong, songsNotFound: SongsNotFound[]): boolean {
  return !!songsNotFound.find((s) => song.artist === s.artist);
}
